// extracted by mini-css-extract-plugin
export default {"container":"jEYm8LUw","tablesContainer":"dCHia4yr","titleContainer":"M74Volqq","item":"xTN5ckLr"};